import AgendamentoContainerService from "../../../services/AgendamentoContainerService";

export default class ParametrosStore {

    terminal;

    agendamentoService;
    parametrosAgendamento;
    tipoAgendamentoAtivo;

    constructor() {
        this.terminal = false;
    };

    // AGENDAMENTO
    isAgendamentoVisible = (campo) => {
        let thing = _.find(this.parametrosAgendamento, { "Id": campo});
        return (thing) ? thing.Visible : false;
    };

    isAgendamentoEnabled = (campo) => {
        let thing = _.find(this.parametrosAgendamento, { "Id": campo});
        return (thing) ? thing.Enabled : false;
    };

    mudaTipoAgendamento = (tipoAgenda) => {
        this.terminal = false;
        if (tipoAgenda != this.tipoAgendamentoAtivo) {
            this.tipoAgendamentoAtivo = tipoAgenda;
            this.agendamentoService.buscarParametros(tipoAgenda).then(response => {
                this.parametrosAgendamento = _.get(response.data, "Campos");
                this.terminal = response.data.Terminal;
            }).catch(error => {
                console.log(error);
            })
        }
    }

    carregarAgendamento = () => {
        this.tipoAgendamentoAtivo = -1;
        if (!this.agendamentoService) {
            this.agendamentoService = new AgendamentoContainerService();
        }
        //this.parametrosAgendamento = this.agendamentoService.buscarParametros();
    }
    // FIM AGENDAMENTO
}


// WEBPACK FOOTER //
// ./src/modules/principal/stores/ParametrosStore.js